import { useState } from 'react';

import { isExist, isString } from '@util/data/is-exist';

export const useLocalStorage = <T = string>(localStorageKey: string): [T | undefined, (v?: T) => void] => {
  const [currentValue, setVale] = useState<T | undefined>(() => {
    if (typeof window === 'undefined') return undefined;
    try {
      const current = window.localStorage.getItem(localStorageKey);

      return isString(current) ? JSON.parse(current) : undefined;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return undefined;
    }
  });

  const handleVale = (value?: T) => {
    setVale(value);
    if (!isExist(value)) return window.localStorage.removeItem(localStorageKey);
    window.localStorage.setItem(localStorageKey, JSON.stringify(value));
  };

  return [currentValue, handleVale];
};
